import {useEffect, useState} from "react";

export const getPointLatLngFromEvent = (event, map) => {
    // Determine if it's a touch event or mouse event
    const clientX = event.touches ? event.touches[0].clientX : event.clientX;
    const clientY = event.touches ? event.touches[0].clientY : event.clientY;

    const rect = map.getDiv().getBoundingClientRect();
    const x = clientX - rect.left;
    const y = clientY - rect.top;
    const projection = map.getProjection();

    if (projection) {
        const bounds = map.getBounds();
        const ne = bounds.getNorthEast();
        const sw = bounds.getSouthWest();
        const topRight = projection.fromLatLngToPoint(ne);
        const bottomLeft = projection.fromLatLngToPoint(sw);
        const scale = Math.pow(2, map.getZoom());

        const worldPoint = new google.maps.Point(
            x / scale + bottomLeft.x,
            y / scale + topRight.y,
        );
        const pixelOffset = 0; // ~ 96/2 for centering the crosshair icon
        const offsetPoint = new google.maps.Point(
            worldPoint.x + pixelOffset / scale,
            worldPoint.y + pixelOffset / scale,
        );
        return projection.fromPointToLatLng(offsetPoint);
    }
    return null;
};

export function getPathLengthInFt(path) {
    const distanceInMeters = google.maps.geometry.spherical.computeLength(path);
    return distanceInMeters * 3.28084;
}

export function getPathAreaInFt(points) {
    const areaInMeters = google.maps.geometry.spherical.computeArea(points);
    return areaInMeters * 10.7639;
}

export function useAppleDevice() {
    const [device, setDevice] = useState(false);

    useEffect(() => {
        const ua = navigator.userAgent || navigator.vendor || window.opera;

        const isIPhone = /iPhone/.test(ua);
        const isIPad = /iPad/.test(ua) ||
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1); // iPadOS 13+

        if (isIPad) {
            setDevice(true);
        } else if (isIPhone) {
            setDevice(true);
        }
    }, []);

    return device;
}

export const getLineLabelPosition = (path) => {
    const centerPoint = google.maps.geometry.spherical.interpolate(path[0], path[1], 0.5);

    return centerPoint;
};

export const getAreaLabelPosition = (path) => {
    const centerPoint = path.slice(0, 3).reduce((acc, point) => ({
        lat: acc.lat + point.lat / 3,
        lng: acc.lng + point.lng / 3,
    }), {lat: 0, lng: 0});

    return centerPoint;
};
